import React from "react";
import ReactDOM from "react-dom/client";
import AppWithQueryProvider from "./AppWithQueryProvider";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./redux/store";
import "./sass/main.scss";
import "/node_modules/flag-icons/css/flag-icons.min.css";
import "react-calendar/dist/Calendar.css";
import "react-datepicker/dist/react-datepicker.css";
import "react-bootstrap-typeahead/css/Typeahead.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import * as Sentry from '@sentry/react';
import SentryUserProvider from "providers/SentryUserProvider";
import ErrorFallback from "components/layout/ErrorFallback";

import "./translation/i18n";
import "./Sentry";

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Root element not found. App cannot be mounted.");

const root = ReactDOM.createRoot(rootElement);
root.render(
  <Sentry.ErrorBoundary fallback={<ErrorFallback />}>
    <Provider store={store}>
      <SentryUserProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/*" element={<AppWithQueryProvider />} />
          </Routes>
        </BrowserRouter>
      </SentryUserProvider>
    </Provider>
  </Sentry.ErrorBoundary>
);
